module.exports = __webpack_public_path__ + "static/media/charter-flights-icon-blue.7a88239f.PNG";